import React from 'react';
import {classes, style} from './doppe-layout-root.st.css';
import {DoppePageFooterBanner} from '../../../doppe-page-footer-banner/doppe-page-footer-banner';
import {
    DoppePagePrivacyAndTermsView
} from '../../../doppe-page-privacy-and-terms-view/doppe-page-privacy-and-terms-view';
import {useBymoPageContextProps} from '../../../../doppe-sdk';
import {
    DoppePageCookieBannerOpener
} from '../../../doppe-page-cookie-consent/doppe-page-cookie-banner-opener/doppe-page-cookie-banner-opener';
import {BymoPageViewerMode, useBymoPageViewerContext} from '../../../bymo-page-viewer-context/bymo-page-viewer-context';
import {useBymoPageProps} from '../../../../client-server-common';
import {useDoppeViewerLocales} from '../../../../client/doppe-viewer-locales/doppe-viewer-locales';

export const DoppeLayoutRoot = React.memo(function DoppeLayoutDefaultProfileView(props: DoppeLayoutRoot.Props) {
    const {
        className,
        children,

        hideFooterBanner = false,
        fullScreen = false,
        ...htmlAttributes
    } = props;
    
    const doppeViewerLocales = useDoppeViewerLocales();
    const bymoPageContextProps = useBymoPageContextProps();
    const bymoPageProps = useBymoPageProps();
    const pageViewerContext = useBymoPageViewerContext();

    const showCookieBanner = bymoPageProps.showCookieBanner;
    const cookieBannerEnabled = (bymoPageContextProps.userCookieBannerSettings?.cookieBannerEnabled)
        && (pageViewerContext.mode === BymoPageViewerMode.Live);
    const userPrivacyPolicyUrl = (bymoPageContextProps.userPrivacyPolicyUrl ?? '').trim();
    const userTermsOfServiceUrl = (bymoPageContextProps.userTermsOfServiceUrl ?? '').trim();
    const hasPrivacyAndTerms = (userPrivacyPolicyUrl || userTermsOfServiceUrl);

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {
                hideFooterBanner: hideFooterBanner,
                hideCookieBanner: !cookieBannerEnabled,
                hidePrivacyAndTerms: !hasPrivacyAndTerms,
                fullScreen: fullScreen,
            }, className)}
        >
            <div
                className={style(classes.main)}
            >
                <div
                    className={style(classes.mainContent, {})}
                >
                    <div className={style(classes.backgroundWrapper, {})}>
                        {children}
                    </div>
                </div>
                {
                    hasPrivacyAndTerms ?
                        <div
                            className={style(classes.privacyAndTermsContainer, {})}
                        >
                            <DoppePagePrivacyAndTermsView
                                className={style(classes.privacyAndTerms, {})}
                            />
                        </div>
                        :
                        null
                }
                {
                    cookieBannerEnabled && showCookieBanner ?
                        <DoppePageCookieBannerOpener
                            className={style(classes.cookieBanner, {})}
                        /> : null
                }
                {
                    !hideFooterBanner ?
                    <DoppePageFooterBanner
                        className={style(classes.contentFooter, {})}
                        bannerMessage={doppeViewerLocales['claim']}
                        targetUrl={`https://www.hopp.co`}
                    />
                    :
                    null
                }
            </div>
        </div>
    )
});

export namespace DoppeLayoutRoot {

    export interface Props extends React.HTMLAttributes<any> {
        hideFooterBanner?: boolean;
        fullScreen?: boolean;
    }
}